import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultGetActionTagName = function defaultGetActionTagName(item) {
  return item.tagName;
};
var defaultGetActionAttributes = function defaultGetActionAttributes(item) {
  return item.attributes;
};
var defaultGetActionDisabled = function defaultGetActionDisabled(item) {
  return item.disabled;
};
var defaultGetActionLabel = function defaultGetActionLabel(item) {
  return item.label;
};
var defaultGetActionOnClick = function defaultGetActionOnClick(item) {
  return item.onClick;
};
var defaultGetActionRef = function defaultGetActionRef(item) {
  return item.ref;
};
var defaultGetActionView = function defaultGetActionView(item) {
  return item.view;
};
var defaultGetActionIconLeft = function defaultGetActionIconLeft(item) {
  return item.iconLeft;
};
var defaultGetActionIconRight = function defaultGetActionIconRight(item) {
  return item.iconRight;
};
export var composePreparedProps = function composePreparedProps(props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    getActionTagName: props.getActionTagName || defaultGetActionTagName,
    getActionAttributes: props.getActionAttributes || defaultGetActionAttributes,
    getActionDisabled: props.getActionDisabled || defaultGetActionDisabled,
    getActionLabel: props.getActionLabel || defaultGetActionLabel,
    getActionOnClick: props.getActionOnClick || defaultGetActionOnClick,
    getActionRef: props.getActionRef || defaultGetActionRef,
    getActionView: props.getActionView || defaultGetActionView,
    getActionIconLeft: props.getActionIconLeft || defaultGetActionIconLeft,
    getActionIconRight: props.getActionIconRight || defaultGetActionIconRight
  });
};
export var defaultSnackBarAnimationTime = 300;
export var getActionParams = function getActionParams(_ref) {
  var action = _ref.action,
    getActionTagName = _ref.getActionTagName,
    getActionAttributes = _ref.getActionAttributes,
    getActionDisabled = _ref.getActionDisabled,
    getActionLabel = _ref.getActionLabel,
    getActionOnClick = _ref.getActionOnClick,
    getActionRef = _ref.getActionRef,
    getActionView = _ref.getActionView,
    getActionIconRight = _ref.getActionIconRight,
    getActionIconLeft = _ref.getActionIconLeft;
  return _objectSpread(_objectSpread({}, getActionAttributes(action) || {}), {}, {
    children: getActionLabel(action),
    tagName: getActionTagName(action),
    view: getActionView(action),
    ref: getActionRef(action),
    disabled: getActionDisabled(action),
    iconLeft: getActionIconLeft(action),
    iconRight: getActionIconRight(action),
    onClick: getActionOnClick(action)
  });
};